import { render } from "./TigerCards.vue?vue&type=template&id=122bbd32&ts=true"
import script from "./TigerCards.vue?vue&type=script&lang=ts"
export * from "./TigerCards.vue?vue&type=script&lang=ts"

import "./TigerCards.vue?vue&type=style&index=0&id=122bbd32&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__